import '../../styles/pages/etc.scss'
import { useState } from 'react'
import axios from 'axios'

const Apply = ({title, sendTo}) => {
    // Consolidated state for form data
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });
    const [file, setFile] = useState(null);
    // Single state for submission status
    const [status, setStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'

    // Handler for text input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileSelect = (event) => {
        setFile(event.target.files[0]);
    };

    const sendEmail = (event) => {
        event.preventDefault();
        setStatus('submitting'); // Disable form and show loading state

        let bodyText = `
        Submitted on: ${new Date()}
        Submitted values are:

        Position: ${title}
        Name: ${formData.name}
        Email Address: ${formData.email}
        Subject: ${formData.subject}
        Message:
        ${formData.message}
        
        ${file !== null ? "Resume Attached Below" : "No Resume Attached"}
        Apply To: ${sendTo}
        `;

        let data = new FormData();
        data.append('name', formData.name);
        data.append('position', title);
        data.append('to', sendTo);
        data.append('email', formData.email);
        data.append('subject', `CAREER SUBMISSION (${title}) | ${formData.name}`);
        data.append('body', bodyText);
        data.append('file', file);

        axios({
            method: "post",
            url: "https://nisamerica.com/emailer/career",
            data: data,
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (response) {
            if (response.data.success) {
                setStatus('success'); // Show success notification
                // Reset form fields
                setFormData({ name: '', email: '', subject: '', message: '' });
                setFile(null);
                event.target.reset(); // Reset the file input
            } else {
                setStatus('error'); // Handle server-side errors
            }
        })
        .catch(function (error) {
            setStatus('error'); // Show error notification
        });
    };

    return (
        <div className="application-container">
            {/* Success Notification */}
            {status === 'success' && (
                <div className="shadow-box visible">
                    <div className="shadow-textbox">
                        <h1>Your application has been successfully submitted!</h1>
                        <button className='close-shadowbox' onClick={() => setStatus('idle')}>Close</button>
                    </div>
                </div>
            )}
            {/* Error Notification */}
            {status === 'error' && (
                <div className="shadow-box visible">
                    <div className="shadow-textbox">
                        <h1>There was an error processing your application</h1>
                        <button className='close-shadowbox' onClick={() => setStatus('idle')}>Close</button>
                    </div>
                </div>
            )}
            <h1 className='app-title'>APPLY</h1>
            <h1 className="header">{title}</h1>
            <form onSubmit={sendEmail}>
                {/* Disable form fields during submission */}
                <fieldset disabled={status === 'submitting'}>
                    <div className="input-wrapper">
                        <input type="text" name="name" required placeholder='Name' className='single-line' value={formData.name} onChange={handleChange} />
                        <input type="email" name="email" required placeholder='Email' className='single-line' value={formData.email} onChange={handleChange}/>
                        <input type="text" name="subject" required placeholder='Subject' className='single-line' value={formData.subject} onChange={handleChange}/>
                        <textarea name="message" required placeholder='Message' className='paragraph' value={formData.message} onChange={handleChange}/>
                    </div>
                    <div className="file-input">
                        <h1>Upload Resume *</h1>
                        <input required className="file-upload" type="file" accept=".gif, .jpg, .jpeg, .png, .txt, .pdf, .doc, .docx" onChange={handleFileSelect}/>
                        <h1>Files must be less than 2 MB.</h1>
                        <h1>Allowed file types: gif, jpg, jpeg, png, txt, pdf, doc, docx.</h1>
                        {/* Update button text based on submission status */}
                        <input className="submit-input" type="submit" value={status === 'submitting' ? 'Submitting...' : 'Submit'}/>
                    </div>
                </fieldset>
            </form>
        </div>
    )
}

export default Apply;